import React from "react";
import styles from "./panel.module.scss";

const PanelTabs: React.FC<{
  testId?: string;
  children?: React.ReactNode;
}> = ({ testId, children }) => {
  return (
    <div data-testid={testId} className={styles.panel_tabs}>
      {children}
    </div>
  );
};

PanelTabs.displayName = "PanelTabs";
export { PanelTabs };
